<scaffold-dialog [title]="data.title" size="half">
  <div scaffoldDialogBody>
    <p-inputgroup>
      <input pInputText [(ngModel)]="searchParam" placeholder="Search Components" fullWidth />
      <p-inputgroup-addon>
        <i class="fas fa-search"></i>
      </p-inputgroup-addon>
    </p-inputgroup>
    <p-accordion multiple="true" [value]="accordionValue">

      <p-accordion-panel *ngFor="let cat of cats; index as i" [value]="i" [style.display]="filter(catagories[cat]).length > 0 ? 'flex':'none'">
        <p-accordion-header>{{cat}}</p-accordion-header>
        <p-accordion-content>
          <div class="row">
            <div class="list-box">
              <div class="list-item" *ngFor="let item of filter(catagories[cat])" (click)="dialogRef.close(cloneDeep(item))" (keydown.enter)="dialogRef.close(cloneDeep(item))" tabindex="0" role="button">
                <div class="col-sm-3 compnent-list-item-label">
                  <i [class]="'fas fa-2xl fa-' + (settings[item.type].icon || 'file')"></i>
                  <div>{{settings[item.type].Name}}</div>
                </div>
                <div class="col-sm-9">
                  <p>{{settings[item.type].description}}</p>
                </div>
              </div>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel *ngIf="premade.length > 0" [value]="cats.length" expanded>
        <p-accordion-header>Pre-Configured Components</p-accordion-header>
        <p-accordion-content>
          <div class="list-box">
            <div class="list-item" *ngFor="let item of premade" (click)="dialogRef.close(cloneDeep(item))" (keydown.enter)="dialogRef.close(cloneDeep(item))" tabindex="0" role="button">
              <div class="col-sm-3 compnent-list-item-label">
                <i [class]="'fas fa-2xl fa-' + (settings[item.type].icon||'file')"></i>
                <div>{{settings[item.type].Name}}</div>
              </div>
              <div class="col-sm-8">
                <p>Configured for {{item.name}}</p>
                <p>{{settings[item.type].description}}</p>
              </div>
            </div>
          </div>          
        </p-accordion-content>
      </p-accordion-panel>

    </p-accordion>
  </div>
</scaffold-dialog>
